import {
  isBegin,
  isFinish,
  strToTime,
  FORMAT_DATE_NORMAL
} from "../common/date";
import { PromotionActivityStatus } from "@/enums/promotion";

/**
 * 获取活动状态
 * @param begin
 * @param end
 */
export const getPromotionStatus = (
  begin: string | number,
  end: string | number,
  formatStr: string | undefined = FORMAT_DATE_NORMAL
) => {
  if (isFinish(end, formatStr)) {
    return PromotionActivityStatus.FINISHED;
  }
  if (isBegin(begin, formatStr)) {
    return PromotionActivityStatus.STARTED;
  }
  return PromotionActivityStatus.NOT_START;
};

/**
 * 秒杀列表排序
 * @param list
 */
export const sortPromotionList = (
  list,
  formatStr: string | undefined = FORMAT_DATE_NORMAL
) => {
  return list.sort((a, b) => {
    // 进行中的在前，未开始的在后
    if (a._promotionStatus !== b._promotionStatus) {
      if (a._promotionStatus === PromotionActivityStatus.FINISHED) {
        return 1;
      }
      if (b._promotionStatus === PromotionActivityStatus.FINISHED) {
        return -1;
      }
      return b._promotionStatus - a._promotionStatus;
    } else {
      // 进行中的，按结束时间排序
      if (a._promotionStatus === PromotionActivityStatus.STARTED) {
        return (
          strToTime(a.countDownEnd, formatStr) -
          strToTime(b.countDownEnd, formatStr)
        );
      }
      // 未开始的，按开始时间排序
      else if (a._promotionStatus === PromotionActivityStatus.NOT_START) {
        return (
          strToTime(a.countDownStart, formatStr) -
          strToTime(b.countDownStart, formatStr)
        );
      }
      return 0;
    }
  });
};

/**
 * 获取第一个图片
 * @param str
 * @param symbol
 */
export const getFirstImage = (str, symbol = ",") => {
  return str?.split(symbol)[0] || "";
};

export const getPromotionCodeByLink = (url: string) => {
  if (!url) return;
  const [, promotionCode] = /.*\/wt-promotion-detail\/(.*)$/gi.exec(url) || [];
  return promotionCode;
};
